import { render, staticRenderFns } from "./distributorSubordinate.vue?vue&type=template&id=45d4e8f6&scoped=true&"
import script from "./distributorSubordinate.vue?vue&type=script&lang=js&"
export * from "./distributorSubordinate.vue?vue&type=script&lang=js&"
import style0 from "./distributorSubordinate.vue?vue&type=style&index=0&id=45d4e8f6&lang=scss&scoped=true&"
import style1 from "./distributorSubordinate.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45d4e8f6",
  null
  
)

export default component.exports